import {initDbStore} from "./initDb";
import moment from "moment";

const historyStoreName = 'history';

export async function saveHistory(item) {
  const db = await initDbStore();

  try {
    const latest = await getHistory();

    // check if item is in DB
    const compare = compareHistory(item, latest);
    if (compare) {
      // delete old record if exists
      await deleteHistoryById(db, compare.id);
    }

    // do not keep more than 10 entries
    if (latest) {
      await deleteOldHistory(db);
    }

    // add record to DB
    await db.add(historyStoreName, {
      ...item,
      createdAt: moment().format('x'),
      updatedAt: moment().format('x'),
    });

    return true;
  } catch (e) {
    console.log(e);
  }

  return false;
}

// check and delete history if there are more than 10 entries
async function deleteOldHistory(db) {
  const count = await db.count(historyStoreName);

  if (count > 10) {
    // delete the oldest record:
    const cursor = await db
      .transaction(historyStoreName, 'readwrite')
      .store
      .index('createdAt')
      .openCursor();

    const {id} = cursor.value;

    if (id) {
      try {
        await cursor.delete();
      } catch (e) {
        console.log(e);
      }
    }

  }
}

async function deleteHistoryById(db, id) {
  return await db.delete(historyStoreName, id);
}

// check if new item exists in DB
function compareHistory(newItem, latestItems = []) {
  for (const index in latestItems) {
    const latestItem = latestItems[index];

    if (newItem && latestItem) {
      if (newItem.type === latestItem.type) {
        switch (newItem.type) {

          // route stop list: compare routeid
          case 'route-details':
            if (newItem.routeid === latestItem.routeid) {
              return {
                id: latestItem.id,
                item: newItem,
              };
            }

            break;

          // route-stop:
          // 1. check if there is exact stop
          // 2. (todo: delete route-stop-list/route-details with the same route ID)
          case 'route-stop':
            if (
              (newItem.routeid === latestItem.routeid) &&
              (newItem.routedir === latestItem.routedir) &&
              (newItem.stopseq === latestItem.stopseq)
            ) {
              return {
                id: latestItem.id,
                item: newItem,
              };
            }

            break;
        }
      }
    }
  }

  // there are no latest items
  return false;
}

// to be KEPT as an example
export async function getLatestHistory() {
  try {
    const db = await initDbStore();

    const cursor = await db
      .transaction(historyStoreName, 'readwrite')
      .store
      .index('createdAt')
      .openCursor(null, 'prev');

    return cursor.value;
  } catch (e) {
    console.log(e);

    return false;
  }
}

// to be KEPT as an example
export async function getTwoLatestHistory() {
  try {
    const db = await initDbStore();

    const cursor = await db
      .transaction(historyStoreName, 'readwrite')
      .store
      .index('createdAt')
      .openCursor(null, 'prev');

    if (!cursor) {
      return [];
    }

    const history = [cursor.value];

    await cursor.continue();

    return [
      ...history,
      cursor.value,
    ];
  } catch (e) {
    console.log(e);

    return false;
  }
}

export async function getHistory() {
  const db = await initDbStore();
  const history = await db.getAll(historyStoreName);

  return history.reverse();
}
